import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const tpvSchema = (
  t: TFunction<'translation', undefined>,
): StringSchema<string | undefined> =>
  stringSchema(t)
    .required(t(formTranslation.errors.fieldRequired))
    .test('must-comply-format', t(formTranslation.errors.noValidFormat), value => {
      if (!value) {
        return false
      }
      return /^[a-zA-Z0-9]+$/.test(value)
    })
    .min(5, t(formTranslation.errors.fieldMinChars, { value: 5 }))
    .max(14, t(formTranslation.errors.maxChars, { value: 14 }))